export default "__VITE_ASSET__9338f7ca__"